<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24" v-if="keynum==1">
          <a-col :span="6">
            <a-form-item label="省份名称">
              <a-input  v-model="queryarr1.provinceName"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="keynum==2">
          <a-col :span="6">
            <a-form-item label="省份名称">
              <a-input  v-model="queryarr2.provinceName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="城市名称">
              <a-input v-model="queryarr2.cityName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="城市等级">
              <a-select v-model="queryarr2.grade" allowClear="true">
                <a-select-option  v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="keynum==3">
          <a-col :span="6">
            <a-form-item label="省份名称">
              <a-input  v-model="queryarr3.provinceName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="城市名称">
              <a-input v-model="queryarr3.cityName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="区域名称">
              <a-input v-model="queryarr3.areaName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="区域等级">
              <a-select v-model="queryarr3.areaGrade" allowClear="true">
                <a-select-option  v-for="(val,key) in fieldType" :key="key" :title="val" :value="key">{{val}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="keynum==4">
          <a-col :span="6">
            <a-form-item label="省份名称">
              <a-input  v-model="queryarr4.provinceName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="城市名称">
              <a-input v-model="queryarr4.cityName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="区域名称">
              <a-input v-model="queryarr4.areaName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6" >
            <a-form-item label="街道名称">
              <a-input v-model="queryarr4.streetName"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <div v-model="keynum"></div>
          <a-col :span="5" :offset="19" style="display: flex;justify-content: flex-end;">
            <a-button type="primary" htmlType="submit" @click="getSelect(1)">查询</a-button>
            <a-button v-if="keynum==1" class="twobtntwobtn" style="margin-left: 8px;" @click="() => queryarr1 = {}">清空</a-button>
            <a-button v-else-if="keynum==2" class="twobtntwobtn" style="margin-left: 8px;" @click="() => queryarr2 = {}">清空</a-button>
            <a-button v-else-if="keynum==3" class="twobtntwobtn" style="margin-left: 8px;" @click="() => queryarr3 = {}">清空</a-button>
            <a-button v-else-if="keynum==4" class="twobtntwobtn" style="margin-left: 8px;" @click="() => queryarr4 = {}">清空</a-button>
          </a-col>
        </a-row>
        <div style="margin-top: 15px">
          <a-tabs defaultActiveKey="1" @change="callback" type="card">
            <a-tab-pane tab="省" key="1">
              <div style="margin-top: 10px;">
                <a-table style="width: 25%" bordered :dataSource="data1" :columns="columnsa" :pagination="false">
                  <span slot="action" slot-scope="text, record"  style="white-space: nowrap">
                    <a v-if="searchEnable" @click="handleEdit1(record,1)">查看</a>
                    <a-divider v-if="searchEnable" type="vertical" />
                    <span v-if="editEnabel">
                      <a @click="handleEdit1(record,0)">编辑</a>
                      <a-divider type="vertical" />
                      <a v-if="record.disable==1" @click="showState(record)">恢复</a>
                      <a v-else @click="showState(record)">禁用</a>
                    </span>
                  </span>
                </a-table>
                <a-pagination
                  showQuickJumper="true"
                  showSizeChanger
                  :pageSizeOptions="pageSizeOptions"
                  :pageSize.sync="pageSize"
                  @showSizeChange="onShowSizeChange"
                  :total="total"
                  v-model="current"
                  @change="getdataList1"
                  :showTotal="total => `总共 ${total} 条`"
                  style="align-content: end"
                />
              </div>
            </a-tab-pane>
            <a-tab-pane tab="市" key="2">
              <div style="margin-top: 10px;">
                <a-table bordered style="width:60%" :dataSource="data2" :columns="columnsb" :pagination="false">
                  <span slot="action" slot-scope="text, record">
                    <a v-if="searchEnable" @click="handleEdit2(record,1)">查看</a>
                    <a-divider v-if="searchEnable" type="vertical" />
                    <span v-if="editEnabel">
                      <a @click="handleEdit2(record)">编辑</a>
                      <!--<a-divider type="vertical"/>-->
                      <!--<a v-if="removeEnable" @click="delByIds(record.channelId)">删除</a>-->
                      <a-divider type="vertical" />
                      <a v-if="record.disable==1" @click="showState(record)">恢复</a>
                      <a v-else @click="showState(record)">禁用</a>
                    </span>
                  </span>
                </a-table>
                <a-pagination
                  showQuickJumper
                  showSizeChanger
                  :pageSizeOptions="pageSizeOptions"
                  :pageSize.sync="pageSize"
                  @showSizeChange="onShowSizeChange"
                  :total="total"
                  v-model="current"
                  @change="getdataList2"
                  :showTotal="total => `总共 ${total} 条`"
                />
              </div>
            </a-tab-pane>
            <a-tab-pane tab="区" key="3">
              <div style="margin-top: 10px;">
                <a-table bordered :dataSource="data3" style="width:60%"  :columns="columnsc" :pagination="false">
                  <span slot="areaGrade" slot-scope="text, record">
                    {{ text | fieldFilter }}
                  </span>
                  <span slot="action" slot-scope="text, record" >
                    <a v-if="searchEnable" @click="handleEdit3(record,1)">查看</a>
                    <a-divider v-if="searchEnable" type="vertical" />
                    <span v-if="editEnabel">
                      <a @click="handleEdit3(record)">编辑</a>
                      <!--<a-divider type="vertical"/>-->
                      <!--<a v-if="removeEnable" @click="delByIds(record.channelId)">删除</a>-->
                      <a-divider type="vertical" />
                      <a v-if="record.disable==1" @click="showState(record)">恢复</a>
                      <a v-else @click="showState(record)">禁用</a>
                    </span>
                  </span>
                </a-table>
                <a-pagination
                  showQuickJumper
                  showSizeChanger
                  :pageSizeOptions="pageSizeOptions"
                  :pageSize.sync="pageSize"
                  @showSizeChange="onShowSizeChange"
                  :total="total"
                  v-model="current"
                  @change="getdataList3"
                  :showTotal="total => `总共 ${total} 条`"
                />
              </div>
            </a-tab-pane>
            <a-tab-pane tab="街道" key="4">
              <div style="margin-top: 10px;">
                <a-table bordered :dataSource="data4" style="width:60%"  :columns="columnsd" :pagination="false">
                  <span slot="action" slot-scope="text, record">
                    <a v-if="searchEnable" @click="handleEdit4(record,1)">查看</a>
                    <a-divider v-if="searchEnable" type="vertical" />
                    <span v-if="editEnabel">
                      <a @click="handleEdit4(record)">编辑</a>
                      <!--<a-divider type="vertical"/>-->
                      <!--<a v-if="removeEnable" @click="delByIds(record.channelId)">删除</a>-->
                      <a-divider type="vertical" />
                      <a v-if="record.disable==1" @click="showState(record)">恢复</a>
                      <a v-else @click="showState(record)">禁用</a>
                    </span>
                  </span>
                </a-table>
                <a-pagination
                  showQuickJumper
                  showSizeChanger
                  :pageSizeOptions="pageSizeOptions"
                  :pageSize.sync="pageSize"
                  @showSizeChange="onShowSizeChange"
                  :total="total"
                  v-model="current"
                  @change="getdataList4"
                  :showTotal="total => `总共 ${total} 条`"
                  style="align-content: end"
                />
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
        <!--         省对话框-->
        <a-modal
          :footer="null"
          v-model="visiablea"
          :maskClosable="false"
        >
          <a-form :form="form" :class="status1 == 1 ? 'readyOnly':''">
            <a-form-item
              label="省份名称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input
                v-model="queryParam.provinceName"
              />
            </a-form-item>
            <a-form-item
              label="省份简称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input
                v-model="queryParam.shortName"
              />
            </a-form-item>
            <a-row>
              <a-col :span="24" style="display: flex;justify-content: center;">
                <div>
                  <a-button type="primary" style="margin-right: 8px" @click="savea">保存</a-button>
                  <a-button @click="cancell">取消</a-button>
                </div>
              </a-col>
            </a-row>
          </a-form>
        </a-modal>
        <!--         市对话框-->
        <a-modal
          :footer="null"
          v-model="visiableb"
          :maskClosable="false"
        >
          <a-form :form="form" :class="status2 == 1 ? 'readyOnly':''">
            <a-form-item
              label="省份名称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-select v-model="queryParam1.provinceCode">
                <a-select-option  v-for="type in pdata" :key="type.provinceCode">{{type.provinceName}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              label="城市简称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input
                v-model="queryParam1.shortName"
              />
            </a-form-item>
            <a-form-item
              label="城市等级"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-select v-model="queryParam1.gradeCode">
                <a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-row>
              <a-col :span="24" style="display: flex;justify-content: center;">
                <div>
                  <a-button type="primary" style="margin-right: 8px" @click="saveb">保存</a-button>
                  <a-button @click="cancell">取消</a-button>
                </div>
              </a-col>
            </a-row>
          </a-form>
        </a-modal>
        <!--         区对话框-->
        <a-modal
          :footer="null"
          v-model="visiablec"
          :maskClosable="false"
        >
          <a-form :form="form" :class="status3 == 1 ? 'readyOnly':''">
            <a-form-item
              label="省份名称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-select v-model="queryParam2.provinceCode" @change="haveProvince1">
                <a-select-option  v-for="type in pdata" :key="type.provinceCode">{{type.provinceName}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              label="城市简称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-select v-model="queryParam2.cityCode">
                <a-select-option  v-for="type in cdata" :key="type.cityCode">{{type.cityName}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              label="区域名称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input
                v-model="queryParam2.areaName"
              />
            </a-form-item>
            <a-form-item
              label="区域等级"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-select v-model="queryParam2.areaGrade">
                <a-select-option  v-for="(val,key) in fieldType" :key="key" :value="key">{{val}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-row>
              <a-col :span="24" style="display: flex;justify-content: center;">
                <div>
                  <a-button type="primary" style="margin-right: 8px" @click="savec">保存</a-button>
                  <a-button @click="cancell">取消</a-button>
                </div>
              </a-col>
            </a-row>
          </a-form>
        </a-modal>
        <!--         街道对话框-->
        <a-modal
          :footer="null"
          v-model="visiabled"
          :maskClosable="false"
        >
          <a-form :form="form" :class="status4 == 1 ? 'readyOnly':''">
            <a-form-item
              label="省份名称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-select v-model="queryParam3.provinceCode" @change="haveProvince2">
                <a-select-option  v-for="type in pdata" :key="type.provinceCode">{{type.provinceName}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              label="城市简称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-select v-model="queryParam3.cityCode" @change="haveProvince3">
                <a-select-option  v-for="type in cdata" :key="type.cityCode">{{type.cityName}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              label="区域名称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-select v-model="queryParam3.areaCode">
                <a-select-option  v-for="type in adata" :key="type.areaCode">{{type.areaName}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              label="街道名称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input
                v-model="queryParam3.streetName"
              />
            </a-form-item>
            <a-row>
              <a-col :span="24" style="display: flex;justify-content: center;">
                <div>
                  <a-button type="primary" style="margin-right: 8px" @click="saved">保存</a-button>
                  <a-button @click="cancell">取消</a-button>
                </div>
              </a-col>
            </a-row>
          </a-form>
        </a-modal>
        <!--禁用-->
        <a-modal
          :footer="null"
          v-model="visiablee"
          :closable="false"
          :maskClosable="false"
        >
          <a-icon type="exclamation-circle" style="margin: 28px 0 25px 43%;font-size: 80px;color: rgb(229, 0, 35)"/>
          <div style="margin-bottom: 30px">
            <h2 style="font-size: 29px;margin-left: 16%">你确定要禁用这条信息吗？</h2>
            <span style="font-size:25px;margin-left: 29%;rgb(134, 143, 147)">禁用后将无法使用!</span>
          </div>
          <div style="margin-left: 35%">
            <a-button style="margin-right: 10px" type="primary" @click="handle1">确定</a-button>
            <a-button @click="handle2">取消</a-button>
          </div>
        </a-modal>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import { checkPermission } from '@/utils/permissions'
import { getProvinceList,getCityList,getAreaList,getStreetList,getProvinceUpdate,getProvinceSave,getCityUpdate,getCitySave,getAreaUpdate,getAreaSave,getStreetUpdate,getStreetSave,fieldType } from '@/api/basicdatas/Provincialdowntownstreet'
import { getDisableProvince,getOpenProvince,getDisableCity,getOpenCity,getDisableArea,getOpenArea,getDisableStreet,getOpenStreet,getSelectAllProvince,getelectCityName,getelectAreaName } from '@/api/basicdatas/Provincialdowntownstreet'
import '@/assets/iconfont/iconfont.css'
import {getDictMap} from "../../utils/dict"

let data1 =[];
let data2 =[];
let data3 =[];
let data4 =[];

export default {
  name: 'Provincialdowntownstreet',
  components: {
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryarr1:{
        provinceName:'',
      },
      queryarr2:{
        gradeCode:'',
        shortName:'',
      },
      queryarr3:{
        areaName:'',
        areaGrade:undefined,
      },
      queryarr4:{
        streetName:''
      },
      // modal绑定参数
      queryParam: {
        shortName:"",
        provinceName:'',
      },
      queryParam1: {
        shortName:"",
        provinceCode:'',
        gradeCode:'',
      },
      queryParam2 : {
        areaName:"",
        provinceCode:'',
        areaGrade:undefined,
        cityCode:''
      },
      queryParam3 : {
        provinceCode:'',
        cityCode:'',
        areaCode:'',
        streetName:''
      },
      data1,
      data2,
      data3,
      data4,
      fieldType,
      columnsa: [
        {
          title: '操作',
          width:80,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }, {
          title: '省份名称',
          dataIndex: 'provinceName',
          align:'center'
        }, {
          title: '省份简称',
          dataIndex: 'shortName',
          align:'center'
        },
      ],
      columnsb: [
        {
          title: '操作',
          width:80,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }, {
          title: '省份名称',
          dataIndex: 'provinceName',
          align:'center'
        }, {
          title: '城市名称',
          dataIndex: 'cityName',
          align:'center'
        }, {
          title: '城市简称',
          dataIndex: 'shortName',
          align:'center'
        }, {
          title: '城市等级',
          dataIndex: 'grade',
          align:'center'
        }
      ],
      columnsc: [
        {
          title: '操作',
          width:60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }, {
          title: '省份名称',
          dataIndex: 'provinceName',
          align:'center'
        }, {
          title: '城市名称',
          dataIndex: 'cityName',
          align:'center'
        }, {
          title: '区域名称',
          dataIndex: 'areaName',
          align:'center'
        }, {
          title: '区域等级',
          dataIndex: 'areaGrade',
          scopedSlots: { customRender: 'areaGrade' },
          align:'center'
        }
      ],
      columnsd: [
        {
          title: '操作',
          dataIndex: 'action',
          width:80,
          scopedSlots: { customRender: 'action' },
        }, {
          title: '省份名称',
          dataIndex: 'provinceName',
          align:'center'
        }, {
          title: '城市名称',
          dataIndex: 'cityName',
          align:'center'
        }, {
          title: '区域名称',
          dataIndex: 'areaName',
          align:'center'
        }, {
          title: '街道名称',
          dataIndex: 'streetName',
          align:'center'
        }
      ],
      visiablea: false,
      visiableb: false,
      visiablec: false,
      visiabled: false,
      visiablee: false,
      keynum:1,
      // getCode:0,
      restaurantTypes:[],
      record:{},
      provinceData:[],
      pdata:[],
      cdata:[],
      adata:[],
      provId:'',
      citId:'',
      // 分页
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      total:0,
      current:1,
      pageSize:10,
      status1:0,
      status2:0,
      status3:0,
      status4:0,
      searchEnable: checkPermission('basicdata:provincialdownstreet:Search'),
      editEnabel: checkPermission('basicdata:provincialdownstreet:Operation'),
    }
  },
  filters: {
    fieldFilter (value) {
      return fieldType[value]
    },
  },
  async created () {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.getSelect(1)
    //   }
    // })
    this.callback(1)
    this.restaurantTypes = [];
    this.restaurantOperTypeMap = await getDictMap('city_grade');
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({code: key, label: value})
    })
  },
  // destroyed () {
  //   document.body.removeEventListener('keyup', e => {})
  // },
  methods: {
    callback (key) {
      this.keynum = key
      this.current=1
      this.getSelect(1)
      // if (key==1){
      //   this.getdataList1()
      //   // getProvinceList({pageNum: value, pageSize: this.pageSize}).then(res=>{
      //   //   // console.log(res.rows)
      //   //   this.data1=res.rows
      //   //   this.total = res.total
      //   // })
      // } else if (key==2){
      //   this.getdataList2()
      // } else if (key==3){
      //   this.getdataList3()
      // } else if (key==4){
      //   this.getdataList4()
      // }
    },
    // 分页
    getdataList1(value = 1) {
      getProvinceList({pageNum: value, pageSize: this.pageSize,provinceName:this.queryarr1.provinceName}).then(res => {
        console.log(res)
        this.data1 = res.rows
        this.total = res.total
      })
    },
    getdataList2(value = 1) {
      getCityList({pageNum: value, pageSize: this.pageSize,provinceName:this.queryarr2.provinceName,cityName:this.queryarr2.cityName,grade:this.queryarr2.grade}).then(res => {
        console.log(res)
        this.data2 = res.rows
        this.total = res.total
      })
    },
    getdataList3(value = 1) {
      getAreaList({pageNum: value, pageSize: this.pageSize,provinceName:this.queryarr3.provinceName,cityName:this.queryarr3.cityName,areaName:this.queryarr3.areaName,areaGrade:this.queryarr3.areaGrade}).then(res => {
        console.log(res)
        this.data3 = res.rows
        this.total = res.total
      })
    },
    getdataList4(value = 1) {
      getStreetList({pageNum: value, pageSize: this.pageSize,provinceName:this.queryarr4.provinceName,cityName:this.queryarr4.cityName,areaName:this.queryarr4.areaName,streetName:this.queryarr4.streetName}).then(res => {
        console.log(res)
        this.data4 = res.rows
        this.total = res.total
      })
    },

    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize;
      this.callback(this.keynum)
    },
    // 查詢
    getSelect(value){
      this.current = value
      if (this.keynum==1){
        getProvinceList({pageNum: value, pageSize: this.pageSize,provinceName:this.queryarr1.provinceName}).then(res=>{
          // console.log(res.rows)
          this.data1=res.rows
          this.total=res.total
        })
      } else if (this.keynum==2){
        getCityList({pageNum: value, pageSize: this.pageSize,provinceName:this.queryarr2.provinceName,cityName:this.queryarr2.cityName,grade:this.queryarr2.grade}).then(res=>{
          // console.log(res.rows)
          this.data2=res.rows
          this.total=res.total
        })
      } else if (this.keynum==3){
        getAreaList({pageNum: value, pageSize: this.pageSize,provinceName:this.queryarr3.provinceName,cityName:this.queryarr3.cityName,areaName:this.queryarr3.areaName,areaGrade:this.queryarr3.areaGrade}).then(res=>{
          // console.log(res.rows)
          this.data3=res.rows
          this.total=res.total
        })
      } else if (this.keynum==4){
        getStreetList({pageNum: value, pageSize: this.pageSize,provinceName:this.queryarr4.provinceName,cityName:this.queryarr4.cityName,areaName:this.queryarr4.areaName,streetName:this.queryarr4.streetName}).then(res=>{
          // console.log(res.rows)
          this.data4=res.rows
          this.total=res.total
        })
      }
    },
    // 新建
    // showModal (keynum) {
    //   this.getCode=0
    //   console.log(keynum)
    //   if (keynum == 1){
    //     this.visiablea=true
    //     this.queryParam={}
    //   } else if (keynum == 2){
    //     this.visiableb=true
    //     this.queryParam1={}
    //   } else if (keynum == 3){
    //     this.visiablec=true
    //     this.queryParam2={}
    //   } else if (keynum == 4) {
    //     this.visiabled=true
    //     this.queryParam3={}
    //   }
    // },
    // 编辑
    handleEdit1(record,status){
      this.record = record
      // this.getCode=1
      this.status1 = status
      this.visiablea=true
      this.queryParam.provinceName=record.provinceName
      this.queryParam.shortName=record.shortName
    },
    handleEdit2(record,status){
      this.record = record
      this.status2 = status
      // this.getCode=1
      this.visiableb = true
      this.queryParam1.provinceCode = record.provinceCode
      this.queryParam1.shortName = record.shortName
      this.queryParam1.gradeCode = record.gradeCode
      getSelectAllProvince().then(res => {
        console.log(res.rows)
        this.pdata = res.rows
      })
    },
    handleEdit3(record,status){
      this.record = record
      this.status3 = status
      this.visiablec=true
      this.queryParam2.provinceCode=record.provinceCode
      this.queryParam2.areaName=record.areaName
      this.queryParam2.areaGrade=record.areaGrade
      this.queryParam2.cityCode=record.cityCode
      getSelectAllProvince().then(res=> {
        // console.log(res.rows)
        this.pdata = res.rows
        this.provId=record.provinceCode
      }).then(res1=>{
        getelectCityName({provinceCode:this.provId}).then(res2=>{
          console.log(res2)
          this.cdata=res2.rows
        })
      })
    },
    handleEdit4(record,status){
      this.visiabled=true
      this.status4 = status
      this.record = record
      this.queryParam3.provinceCode=record.provinceCode
      this.queryParam3.areaCode=record.areaCode
      this.queryParam3.cityCode=record.cityCode
      this.queryParam3.streetName=record.streetName
      getSelectAllProvince().then(res=> {
        // console.log(res.rows)
        this.pdata = res.rows
        this.provId=record.provinceCode
      }).then(res1=>{
        // console.log(res1)
        getelectCityName({provinceCode:this.provId}).then(res2=>{
          // console.log(res2)
          this.cdata=res2.rows
          this.citId=record.cityCode
        })
      }).then(res3=>{
        // console.log(res3)
        getelectAreaName({cityCode:this.citId}).then(res4=>{
          // console.log(res4)
          this.adata=res4.rows
        })
      })
    },

    // handleEdit(record){
    //   console.log(record)
    //   this.record = record
    //   this.getCode=1
    //   if (this.keynum==1){
    //     this.visiablea=true
    //     this.queryParam.provinceName=record.provinceName
    //     this.queryParam.shortName=record.shortName
    //   } else if (this.keynum == 2){
    //     this.visiableb=true
    //     this.queryParam1.provinceCode=record.provinceCode
    //     this.queryParam1.shortName=record.shortName
    //     this.queryParam1.gradeCode=record.gradeCode
    //     getSelectAllProvince().then(res=> {
    //       console.log(res.rows)
    //       this.pdata = res.rows
    //     })
    //   } else if (this.keynum == 3){
    //     this.visiablec=true
    //     this.queryParam2.provinceName=record.provinceName
    //     this.queryParam2.areaName=record.areaName
    //     this.queryParam2.areaGrade=record.areaGrade
    //     this.queryParam2.cityCode=record.cityCode
    //     getSelectAllProvince().then(res=> {
    //       console.log(res.rows)
    //       this.pdata = res.rows
    //       this.provId=record.provinceCode
    //     })
    //   } else if (this.keynum == 4) {
    //     this.visiabled=true
    //     this.queryParam3.provinceName=record.provinceName
    //     this.queryParam3.areaName=record.areaName
    //     this.queryParam3.cityName=record.cityName
    //     this.queryParam3.streetName=record.streetName
    //   }
    // },
    // model 取消

    cancell(){
      if (this.keynum==1){
        this.visiablea=false
      } else if (this.keynum==2){
        this.visiableb=false
      } else if (this.keynum==3){
        this.visiablec=false
      } else if (this.keynum==4) {
        this.visiabled=false
      }
    },
    // model 新建/编辑
    savea () {
      // if(this.getCode==0){
      //   getProvinceSave({provinceName:this.queryParam.provinceName,shortName:this.queryParam.shortName}).then(res=>{
      //     if (res.code === 0) {
      //       this.callback(this.keynum)
      //       this.$message.success('添加成功')
      //       this.visiablea=false
      //     } else {
      //       this.$message.error(res.msg)
      //     }
      //   })
      // }else if (this.getCode==1){
        getProvinceUpdate({provinceId:this.record.provinceId,provinceName:this.queryParam.provinceName,shortName:this.queryParam.shortName}).then(res=>{
          if (res.code === 0) {
            this.$message.success(res.data)
            this.getSelect(this.current)
            this.visiablea=false
          } else {
            this.$message.error(res.msg)
          }
        })
      // }
    },
    saveb () {
      getCityUpdate({cityId:this.record.cityId,provinceCode:this.queryParam1.provinceCode,shortName:this.queryParam1.shortName,grade:this.queryParam1.gradeCode}).then(res=>{
        if (res.code === 0) {
          this.$message.success(res.data)
          this.getSelect(this.current)
          this.visiableb=false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    savec () {
      getAreaUpdate({areaId:this.record.areaId,provinceCode:this.queryParam2.provinceCode,cityCode:this.queryParam2.cityCode,areaName:this.queryParam2.areaName,areaGrade:this.queryParam2.areaGrade}).then(res=>{
        if (res.code === 0) {
          this.$message.success(res.data)
          this.getSelect(this.current)
          this.visiablec=false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    saved () {
      getStreetUpdate({
        streetId: this.record.streetId,
        provinceCode: this.queryParam3.provinceCode,
        cityCode: this.queryParam3.cityCode,
        areaCode: this.queryParam3.areaCode,
        streetName: this.queryParam3.streetName,
      }).then(res => {
        if (res.code === 0) {
          this.$message.success(res.data)
          this.getSelect(this.current)
          this.visiabled = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // modal下拉
    haveProvince1(){
      // console.log(this.queryParam2.provinceCode)
      getelectCityName({provinceCode:this.queryParam2.provinceCode}).then(res=>{
        console.log(res)
        this.cdata=res.rows
      })
    },
    haveProvince2(){
      // console.log(this.queryParam3.provinceCode)
      getelectCityName({provinceCode:this.queryParam3.provinceCode}).then(res=>{
        console.log(res)
        this.cdata=res.rows
      })
    },
    haveProvince3(){
      // console.log(this.queryParam3.provinceCode)
      getelectAreaName({cityCode:this.queryParam3.cityCode}).then(res=>{
        console.log(res)
        this.adata=res.rows
      })
    },


    // 禁用、恢复
    showState(record){
      console.log(record)
      this.record=record
      if (this.keynum==1){
        if (record.disable == 0) {
          this.visiablee=true
        }else{
          getOpenProvince({provinceId: record.provinceId}).then(res => {
            if (res.code === 0) {
              this.getSelect(this.current)
              this.$message.success('恢复成功')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      } else if (this.keynum==2){
        if (record.disable == 0) {
          this.visiablee=true
        }else{
          getOpenCity({cityId: record.cityId}).then(res => {
            if (res.code === 0) {
              this.getSelect(this.current)
              this.$message.success('恢复成功')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      } else if (this.keynum==3){
        if (record.disable == 0) {
          this.visiablee=true
        }else{
          getOpenArea({areaId: record.areaId}).then(res => {
            if (res.code === 0) {
              this.getSelect(this.current)
              this.$message.success('恢复成功')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      } else if (this.keynum==4){
        if (record.disable == 0) {
          this.visiablee=true
        }else{
          getOpenStreet({streetId: record.streetId}).then(res => {
            if (res.code === 0) {
              this.getSelect(this.current)
              this.$message.success('恢复成功')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      }
    },

    // modal页确定禁用
    handle1(){
      console.log(this.current)
      if (this.keynum==1) {
        getDisableProvince({provinceId: this.record.provinceId}).then(res => {
          if (res.code === 0) {
            // this.getdataList1()
            this.getSelect(this.current)
            this.$message.success('禁用成功')
            this.visiablee=false
          } else {
            this.$message.error(res.msg)
          }
        })
      }else if (this.keynum==2){
        getDisableCity({cityId: this.record.cityId}).then(res => {
          if (res.code === 0) {
            this.getSelect(this.current)
            this.$message.success('禁用成功')
            this.visiablee=false
          } else {
            this.$message.error(res.msg)
          }
        })
      }else if (this.keynum==3){
        getDisableArea({areaId: this.record.areaId}).then(res => {
          if (res.code === 0) {
            this.getSelect(this.current)
            this.$message.success('禁用成功')
            this.visiablee=false
          } else {
            this.$message.error(res.msg)
          }
        })
      }else if (this.keynum==4){
        getDisableStreet({streetId: this.record.streetId}).then(res => {
          if (res.code === 0) {
            this.getSelect(this.current)
            this.$message.success('禁用成功')
            this.visiablee=false
          } else {
            this.$message.error(res.msg)
          }
        })
      }

    },
    handle2(){
      this.visiablee=false
    }
  }
}
</script>

<style scoped>
  .twobtn{
    /*background-color: #409EFF;*/
    /*color: white;*/

    font-size: 15px;
  }
  /*/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active{*/
  /*  width: 200px;*/
  /*  text-align: center;*/
  /*}*/
  /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab{
    width: 50%;
    text-align: center;
  }
  /deep/ .ant-tabs-tab-active{
    /*background-color: #409EFF;*/
    color: white;
  }
  /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active{
    /*background-color: #409EFF;*/
    /*color: white;*/
  }
  /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab{
    /*margin:5px*/
  }
  .ant-pagination{
    /*margin-left: 43%;*/
    margin:20px 40px 0 0;
    display:flex;
    justify-content:flex-end;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap;padding: 4px 16px;}
  .readyOnly{
    pointer-events: none;
  }
</style>
